import styled from "styled-components";

export const GeneralContainerPages = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
`;